import React, { useEffect, useState, useRef } from "react";
import "./CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../API/FeedBackLuzes";

const GroupLightComponent = () => {
  const groupRefs = useRef({
    grupo05: React.createRef(),
    grupo07: React.createRef(),
    grupo13: React.createRef(),
    grupo14: React.createRef(),
    grupo16: React.createRef(),
    grupo17: React.createRef(),
    grupo18: React.createRef(),
    grupo20: React.createRef(),
    grupo21: React.createRef(),
    grupo22: React.createRef(),
    grupo23: React.createRef(),
    grupo24: React.createRef(),
    grupo25: React.createRef(),
    grupo27: React.createRef(),

  });

  const [imageStates, setImageStates] = useState({
    grupo05: false,
    grupo07: false,
    grupo13: false,
    grupo14: false,
    grupo16: false,
    grupo17: false,
    grupo18: false,
    grupo20: false,
    grupo21: false,
    grupo22: false,
    grupo23: false,
    grupo24: false,
    grupo25: false,
    grupo27: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      setLoading(false);
      console.log("Status das luzes:", statusDasLuzesFlex35);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8300);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo05: statusDasLuzesFlex35.includes("1E10") && !statusDasLuzesFlex35.includes("1E00"),
      grupo07: statusDasLuzesFlex35.includes("1G10") && !statusDasLuzesFlex35.includes("1G00"),
      grupo13: statusDasLuzesFlex35.includes("1M10") && !statusDasLuzesFlex35.includes("1M00"),
      grupo14: statusDasLuzesFlex35.includes("1N10") && !statusDasLuzesFlex35.includes("1N00"),
      grupo16: statusDasLuzesFlex35.includes("1P10") && !statusDasLuzesFlex35.includes("1P00"),
      grupo17: statusDasLuzesFlex35.includes("1Q10") && !statusDasLuzesFlex35.includes("1Q00"),
      grupo18: statusDasLuzesFlex35.includes("1R10") && !statusDasLuzesFlex35.includes("1R00"),
      grupo20: statusDasLuzesFlex35.includes("1T10") && !statusDasLuzesFlex35.includes("1T00"),
      grupo21: statusDasLuzesFlex35.includes("1U10") && !statusDasLuzesFlex35.includes("1U00"),
      grupo22: statusDasLuzesFlex35.includes("1V10") && !statusDasLuzesFlex35.includes("1V00"),
      grupo23: statusDasLuzesFlex35.includes("1W10") && !statusDasLuzesFlex35.includes("1W00"),
      grupo24: statusDasLuzesFlex35.includes("1X10") && !statusDasLuzesFlex35.includes("1X00"),
      grupo25: statusDasLuzesFlex35.includes("1Y10") && !statusDasLuzesFlex35.includes("1Y00"),
      grupo27: statusDasLuzesFlex35.includes("1a10") && !statusDasLuzesFlex35.includes("1a00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      {/* Grupo 5 */}
      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo05}
        groupId="grupo05"
        descricao="Varanda Gourmet"
        imageUrl={imageStates.grupo05 ? Ligado : Desligado}
        onCommand="1E10"
        offCommand="1E00"
        x={39.05}
        y={67.2}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo05}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo05}
        groupId="grupo05"
        descricao="Varanda Gourmet"
        imageUrl={imageStates.grupo05 ? Ligado : Desligado}
        onCommand="1E10"
        offCommand="1E00"
        x={48.9}
        y={67.5}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo05}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo05}
        groupId="grupo05"
        descricao="Varanda Gourmet"
        imageUrl={imageStates.grupo05 ? Ligado : Desligado}
        onCommand="1E10"
        offCommand="1E00"
        x={49.75}
        y={47.7}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo05}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo05}
        groupId="grupo05"
        descricao="Varanda Gourmet"
        imageUrl={imageStates.grupo05 ? Ligado : Desligado}
        onCommand="1E10"
        offCommand="1E00"
        x={39.65}
        y={59.2}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo05}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 7 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo07}
        groupId="grupo07"
        descricao="SPA"
        imageUrl={imageStates.grupo07 ? Ligado : Desligado}
        onCommand="1G10"
        offCommand="1G00"
        x={47.15}
        y={42.4}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo07}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 13 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo13}
        groupId="grupo13"
        descricao="Arandelas"
        imageUrl={imageStates.grupo13 ? Ligado : Desligado}
        onCommand="1M10"
        offCommand="1M00"
        x={49.75}
        y={38.7}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo13}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo13}
        groupId="grupo13"
        descricao="Arandelas"
        imageUrl={imageStates.grupo13 ? Ligado : Desligado}
        onCommand="1M10"
        offCommand="1M00"
        x={57.45}
        y={38.7}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo13}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo13}
        groupId="grupo13"
        descricao="Arandelas"
        imageUrl={imageStates.grupo13 ? Ligado : Desligado}
        onCommand="1M10"
        offCommand="1M00"
        x={55.5}
        y={75.2}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo13}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo13}
        groupId="grupo13"
        descricao="Arandelas"
        imageUrl={imageStates.grupo13 ? Ligado : Desligado}
        onCommand="1M10"
        offCommand="1M00"
        x={61.35}
        y={75.2}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo13}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 14 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo14}
        groupId="grupo14"
        descricao="Postes lazer"
        imageUrl={imageStates.grupo14 ? Ligado : Desligado}
        onCommand="1N10"
        offCommand="1N00"
        x={53.55}
        y={50.8}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo14}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo14}
        groupId="grupo14"
        descricao="Postes lazer"
        imageUrl={imageStates.grupo14 ? Ligado : Desligado}
        onCommand="1N10"
        offCommand="1N00"
        x={53.85}
        y={59.7}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo14}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo14}
        groupId="grupo14"
        descricao="Postes lazer"
        imageUrl={imageStates.grupo14 ? Ligado : Desligado}
        onCommand="1N10"
        offCommand="1N00"
        x={53.3}
        y={66.6}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo14}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo14}
        groupId="grupo14"
        descricao="Postes lazer"
        imageUrl={imageStates.grupo14 ? Ligado : Desligado}
        onCommand="1N10"
        offCommand="1N00"
        x={58.55}
        y={53.5}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo14}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo14}
        groupId="grupo14"
        descricao="Postes lazer"
        imageUrl={imageStates.grupo14 ? Ligado : Desligado}
        onCommand="1N10"
        offCommand="1N00"
        x={59.6}
        y={60.7}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo14}
        onToggleLightGroup={handleToggleLightGroup} 
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo14}
        groupId="grupo14"
        descricao="Postes lazer"
        imageUrl={imageStates.grupo14 ? Ligado : Desligado}
        onCommand="1N10"
        offCommand="1N00"
        x={60.65}
        y={66.0}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo14}
        onToggleLightGroup={handleToggleLightGroup}
      />
        
      {/* Grupo 16 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo16}
        groupId="grupo16"
        descricao="Floreira Degraus"
        imageUrl={imageStates.grupo16 ? Ligado : Desligado}
        onCommand="1P10"
        offCommand="1P00"
        x={58.25}
        y={75.2}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo16}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo16}
        groupId="grupo16"
        descricao="Floreira Degraus"
        imageUrl={imageStates.grupo16 ? Ligado : Desligado}
        onCommand="1P10"
        offCommand="1P00"
        x={56.55}
        y={51.4}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo16}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo16}
        groupId="grupo16"
        descricao="Floreira Degraus"
        imageUrl={imageStates.grupo16 ? Ligado : Desligado}
        onCommand="1P10"
        offCommand="1P00"
        x={58.45}
        y={65.5}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo16}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo16}
        groupId="grupo16"
        descricao="Floreira Degraus"
        imageUrl={imageStates.grupo16 ? Ligado : Desligado}
        onCommand="1P10"
        offCommand="1P00"
        x={51.25}
        y={75.2}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo16}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo16}
        groupId="grupo16"
        descricao="Floreira Degraus"
        imageUrl={imageStates.grupo16 ? Ligado : Desligado}
        onCommand="1P10"
        offCommand="1P00"
        x={57.45}
        y={59.3}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo16}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo16}
        groupId="grupo16"
        descricao="Floreira Degraus"
        imageUrl={imageStates.grupo16 ? Ligado : Desligado}
        onCommand="1P10"
        offCommand="1P00"
        x={53.35}
        y={62.7}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo16}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo16}
        groupId="grupo16"
        descricao="Floreira Degraus"
        imageUrl={imageStates.grupo16 ? Ligado : Desligado}
        onCommand="1P10"
        offCommand="1P00"
        x={53.75}
        y={56.6}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo16}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo16}
        groupId="grupo16"
        descricao="Floreira Degraus"
        imageUrl={imageStates.grupo16 ? Ligado : Desligado}
        onCommand="1P10"
        offCommand="1P00"
        x={62.65}
        y={71.4}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo16}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 17 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo17}
        groupId="grupo17"
        descricao="Piscina Subaquático"
        imageUrl={imageStates.grupo17 ? Ligado : Desligado}
        onCommand="1Q10"
        offCommand="1Q00"
        x={61.75}
        y={55.0}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo17}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 18 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo18}
        groupId="grupo18"
        descricao="Floreira Piscina"
        imageUrl={imageStates.grupo18 ? Ligado : Desligado}
        onCommand="1R10"
        offCommand="1R00"
        x={64.25}
        y={59.4}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo18}
        onToggleLightGroup={handleToggleLightGroup}
      />
    
      {/* Grupo 20 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo20}
        groupId="grupo20"
        descricao="Arandelas Piscina"
        imageUrl={imageStates.grupo20 ? Ligado : Desligado}
        onCommand="1T10"
        offCommand="1T00"
        x={74.25}
        y={66.3}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo20}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 21 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo21}
        groupId="grupo21"
        descricao="Floreiras"
        imageUrl={imageStates.grupo21 ? Ligado : Desligado}
        onCommand="1U10"
        offCommand="1U00"
        x={78.35}
        y={73.4}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo21}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo21}
        groupId="grupo21"
        descricao="Floreiras"
        imageUrl={imageStates.grupo21 ? Ligado : Desligado}
        onCommand="1U10"
        offCommand="1U00"
        x={71.45}
        y={60.6}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo21}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo21}
        groupId="grupo21"
        descricao="Floreiras"
        imageUrl={imageStates.grupo21 ? Ligado : Desligado}
        onCommand="1U10"
        offCommand="1U00"
        x={72.65}
        y={68.3}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo21}
        onToggleLightGroup={handleToggleLightGroup}
      />

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo21}
        groupId="grupo21"
        descricao="Floreiras"
        imageUrl={imageStates.grupo21 ? Ligado : Desligado}
        onCommand="1U10"
        offCommand="1U00"
        x={76.75}
        y={65.7}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo21}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 22 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo22}
        groupId="grupo22"
        descricao="Quadra de tênis"
        imageUrl={imageStates.grupo22 ? Ligado : Desligado}
        onCommand="1V10"
        offCommand="1V00"
        x={77.15}
        y={51.4}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo22}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 23 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo23}
        groupId="grupo23"
        descricao="Quadra poliesportiva"
        imageUrl={imageStates.grupo23 ? Ligado : Desligado}
        onCommand="1W10"
        offCommand="1W00"
        x={67.95}
        y={47.8}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo23}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 24 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo24}
        groupId="grupo24"
        descricao="Quadra beach tennis"
        imageUrl={imageStates.grupo24 ? Ligado : Desligado}
        onCommand="1X10"
        offCommand="1X00"
        x={67.75}
        y={62.6}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo24}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 25 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo25}
        groupId="grupo25"
        descricao="Tomadas Gourmet"
        imageUrl={imageStates.grupo25 ? Ligado : Desligado}
        onCommand="1Y10"
        offCommand="1Y00"
        x={81.85}
        y={67.0}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo25}
        onToggleLightGroup={handleToggleLightGroup}
      />

      {/* Grupo 27 */}

      <LightGroup
        className="light_button"
        ref={groupRefs.current.grupo27}
        groupId="grupo27"
        descricao="Cervejeira Salão de Festas"
        imageUrl={imageStates.grupo27 ? Ligado : Desligado}
        onCommand="1[10"
        offCommand="1[00"
        x={44.45}
        y={61.4}
        width={1.5}
        height={2.5}
        imageState={imageStates.grupo27}
        onToggleLightGroup={handleToggleLightGroup}
      />


        {/* Legenda de acionamentos */}

        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '40.4%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo05', !imageStates.grupo05); groupRefs.current.grupo05.current.sendCommand(groupRefs.current.grupo05.current.props.descricao, imageStates.grupo05 ? groupRefs.current.grupo05.current.props.offCommand : groupRefs.current.grupo05.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo05 ? 'Highlighted' : ''}`}>5</p>
          <p className="textBar">Varanda Gourmet</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '44.2%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo07', !imageStates.grupo07); groupRefs.current.grupo07.current.sendCommand(groupRefs.current.grupo07.current.props.descricao, imageStates.grupo07 ? groupRefs.current.grupo07.current.props.offCommand : groupRefs.current.grupo07.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo07 ? 'Highlighted' : ''}`}>7</p>
          <p className="textBar">SPA</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '48%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo13', !imageStates.grupo13); groupRefs.current.grupo13.current.sendCommand(groupRefs.current.grupo13.current.props.descricao, imageStates.grupo13 ? groupRefs.current.grupo13.current.props.offCommand : groupRefs.current.grupo13.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo13 ? 'Highlighted' : ''}`}>13</p>
          <p className="textBar">Arandelas</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '51.8%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo14', !imageStates.grupo14); groupRefs.current.grupo14.current.sendCommand(groupRefs.current.grupo14.current.props.descricao, imageStates.grupo14 ? groupRefs.current.grupo14.current.props.offCommand : groupRefs.current.grupo14.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo14 ? 'Highlighted' : ''}`}>14</p>
          <p className="textBar">Postes lazer</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '55.6%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo16', !imageStates.grupo16); groupRefs.current.grupo16.current.sendCommand(groupRefs.current.grupo16.current.props.descricao, imageStates.grupo16 ? groupRefs.current.grupo16.current.props.offCommand : groupRefs.current.grupo16.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo16 ? 'Highlighted' : ''}`}>16</p>
          <p className="textBar">Floreira Degraus</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '59.4%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo17', !imageStates.grupo17); groupRefs.current.grupo17.current.sendCommand(groupRefs.current.grupo17.current.props.descricao, imageStates.grupo17 ? groupRefs.current.grupo17.current.props.offCommand : groupRefs.current.grupo17.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo17 ? 'Highlighted' : ''}`}>17</p>
          <p className="textBar">Piscina Subaquático</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '63.2%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo18', !imageStates.grupo18); groupRefs.current.grupo18.current.sendCommand(groupRefs.current.grupo18.current.props.descricao, imageStates.grupo18 ? groupRefs.current.grupo18.current.props.offCommand : groupRefs.current.grupo18.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo18 ? 'Highlighted' : ''}`}>18</p>
          <p className="textBar">Floreira Piscina</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '67%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo20', !imageStates.grupo20); groupRefs.current.grupo20.current.sendCommand(groupRefs.current.grupo20.current.props.descricao, imageStates.grupo20 ? groupRefs.current.grupo20.current.props.offCommand : groupRefs.current.grupo20.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo20 ? 'Highlighted' : ''}`}>20</p>
          <p className="textBar">Arandelas Piscina</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '70.8%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo21', !imageStates.grupo21); groupRefs.current.grupo21.current.sendCommand(groupRefs.current.grupo21.current.props.descricao, imageStates.grupo21 ? groupRefs.current.grupo21.current.props.offCommand : groupRefs.current.grupo21.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo21 ? 'Highlighted' : ''}`}>21</p>
          <p className="textBar">Floreiras</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '74.6%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo22', !imageStates.grupo22); groupRefs.current.grupo22.current.sendCommand(groupRefs.current.grupo22.current.props.descricao, imageStates.grupo22 ? groupRefs.current.grupo22.current.props.offCommand : groupRefs.current.grupo22.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo22 ? 'Highlighted' : ''}`}>22</p>
          <p className="textBar">Quadra de tênis</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '78.3%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo23', !imageStates.grupo23); groupRefs.current.grupo23.current.sendCommand(groupRefs.current.grupo23.current.props.descricao, imageStates.grupo23 ? groupRefs.current.grupo23.current.props.offCommand : groupRefs.current.grupo23.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo23 ? 'Highlighted' : ''}`}>23</p>
          <p className="textBar">Quadra poliesportiva</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '82.1%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo24', !imageStates.grupo24); groupRefs.current.grupo24.current.sendCommand(groupRefs.current.grupo24.current.props.descricao, imageStates.grupo24 ? groupRefs.current.grupo24.current.props.offCommand : groupRefs.current.grupo24.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo24 ? 'Highlighted' : ''}`}>24</p>
          <p className="textBar">Quadra beach tennis</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '85.9%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo25', !imageStates.grupo25); groupRefs.current.grupo25.current.sendCommand(groupRefs.current.grupo25.current.props.descricao, imageStates.grupo25 ? groupRefs.current.grupo25.current.props.offCommand : groupRefs.current.grupo25.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo25 ? 'Highlighted' : ''}`}>25</p>
          <p className="textBar">Tomadas Gourmet</p>
        </div>
        <div
          id="campoGroup-page3"
          className="campoGroup-clickable-element"
          style={{ top: '89.7%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo27', !imageStates.grupo27); groupRefs.current.grupo27.current.sendCommand(groupRefs.current.grupo27.current.props.descricao, imageStates.grupo27 ? groupRefs.current.grupo27.current.props.offCommand : groupRefs.current.grupo27.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo27 ? 'Highlighted' : ''}`}>27</p>
          <p className="textBar">Cervejeira Salão de Festas</p>
        </div>           
    </> 
  );

};

export default React.memo(GroupLightComponent);
